const NUMBER_LOCALE = { ru: 'ru-RU', en: 'en-US' };
const baht = (minor, lang) => `${new Intl.NumberFormat(NUMBER_LOCALE[lang], { maximumFractionDigits: 2 }).format(minor / 100)} ฿`;
/** «1 день, 3 дня, 14 дней, 21 день». */
const daysRu = (count) => {
    const tens = count % 100;
    const units = count % 10;
    if (units === 1 && tens !== 11) {
        return `${String(count)} день`;
    }
    if (units >= 2 && units <= 4 && (tens < 12 || tens > 14)) {
        return `${String(count)} дня`;
    }
    return `${String(count)} дней`;
};
const giftLine = (gift, lang) => {
    switch (gift.kind) {
        case 'FREE_ITEM':
            return lang === 'ru' ? `${gift.itemName} в подарок` : `${gift.itemName} as a gift`;
        case 'FIXED_OFF':
            return lang === 'ru' ? `Скидка ${baht(gift.amount, lang)}` : `${baht(gift.amount, lang)} off`;
        case 'PERCENT_OFF': {
            const percent = String(gift.percent);
            if (gift.maxDiscount === null) {
                return lang === 'ru' ? `Скидка ${percent}%` : `${percent}% off`;
            }
            return lang === 'ru'
                ? `Скидка ${percent}%, но не больше ${baht(gift.maxDiscount, lang)}`
                : `${percent}% off, up to ${baht(gift.maxDiscount, lang)}`;
        }
    }
};
const steps = (reward, limits, lang) => {
    if (reward.kind === 'GIFT_CODE') {
        return [
            lang === 'ru' ? 'Покажите код на кассе' : 'Show the code at the till',
            giftLine(reward.gift, lang),
            lang === 'ru'
                ? `Действует ${daysRu(reward.validityDays)} с выдачи`
                : `Valid for ${String(reward.validityDays)} day${reward.validityDays === 1 ? '' : 's'}`,
        ];
    }
    const minCheck = limits.minCheck ?? null;
    return [
        lang === 'ru'
            ? `Кэшбэк ${String(reward.percent)}% баллами — начисляется к чеку сам`
            : `${String(reward.percent)}% cashback in points — added to the receipt automatically`,
        ...(minCheck === null
            ? []
            : [
                lang === 'ru'
                    ? `При чеке от ${baht(minCheck, lang)}`
                    : `With a check of ${baht(minCheck, lang)} or more`,
            ]),
    ];
};
export const engineOfferTexts = (input) => ({
    title: { ru: input.title, en: input.title },
    howTo: {
        ru: steps(input.reward, input.limits, 'ru'),
        en: steps(input.reward, input.limits, 'en'),
    },
});
//# sourceMappingURL=offer-texts.js.map